<template>
<!--  <v-expansion-panel expand='true'>-->
<!--    <v-expansion-panel-content v-for="group in groups" :key="group.title">-->
<!--      <template v-slot:header>-->
<!--        <div class="font-weight-bold">{{ group.description }}</div>-->
<!--      </template>-->
<!--      <ParameterGroup v-bind:showAdvanced="showAdvanced" v-bind:group="group"></ParameterGroup>-->
<!--    </v-expansion-panel-content>-->
<!--  </v-expansion-panel>-->
  <v-layout column>
    <v-flex v-for="group in groups" :key="group.title">
      <ParameterGroup
          :vectorizers="vectorizers"
          :searchParamsBuilders="searchParamsBuilders"
          :compact="compact"
          :showAdvanced="showAdvanced"
          :showDefinedOnly="showDefinedOnly"
          :group="group"
          :languageRestrictions="languageRestrictions"
      ></ParameterGroup>
    </v-flex>
  </v-layout>
</template>

<script>
import ParameterGroup from "./ParameterGroup";

export default {
  props: ["groups", "showAdvanced", "showDefinedOnly", "compact", "languageRestrictions"],
  components: {
    ParameterGroup
  },
  data: () => ({
    vectorizers: [],
    searchParamsBuilders: [],
  }),
  async mounted() {
    const vectorizers = await this.$store._getPlansByTag("vectorization")
    this.vectorizers = vectorizers.map(it => ({name: it.name, label: it.label}))
    const searchParamsBuilders = await this.$store._getPlansByTag("search-params-builder")
    this.searchParamsBuilders = searchParamsBuilders.map(it => ({name: it.name, label: it.label}))
  }
};
</script>